import { typography } from '../../../theme/tokens/typography';

/**
 * MRT slot overrides — all colors from semantic.table tokens.
 */
export function createTableStyles({ semantic, density, typography: typo = typography }) {
  const table = semantic.table ?? {};
  const rowHeight = density?.rowHeight ?? table.rowHeight ?? 56;
  const cellPaddingX = table.cellPaddingX ?? 20;
  const borderColor = table.borderColor ?? semantic.borders.border;
  const headerBg = table.headerBackground ?? semantic.surfaces.surfaceSubtle;
  const headerColor = table.headerText ?? semantic.text.primary;

  return {
    container: {
      sx: {
        width: '100%',
        maxHeight: 'none !important',
        height: 'auto !important',
        overflowX: 'auto',
        overflowY: 'visible !important',
        borderRadius: 0,
        boxShadow: 'none',
        border: 'none',
      },
    },
    headRow: {
      sx: {
        backgroundColor: headerBg,
        boxShadow: 'none',
        position: 'static',
      },
    },
    headCell: {
      sx: {
        backgroundColor: `${headerBg} !important`,
        color: `${headerColor} !important`,
        fontWeight: typo.fontWeightSemibold,
        fontSize: typo.fontSizeSm,
        lineHeight: 1.4,
        textTransform: 'none',
        letterSpacing: '0.01em',
        borderBottom: `1px solid ${borderColor}`,
        py: 1.5,
        px: `${cellPaddingX}px`,
        height: 44,
        verticalAlign: 'middle',
        position: 'static',
        top: 'auto',
        zIndex: 'auto',
        opacity: 1,
        '& .Mui-TableHeadCell-Content': {
          color: `${headerColor} !important`,
          opacity: 1,
        },
        '& .Mui-TableHeadCell-Content-Labels': {
          color: `${headerColor} !important`,
          gap: 0.5,
          opacity: 1,
        },
        '& .Mui-TableHeadCell-Content-Wrapper': {
          opacity: 1,
        },
        '& .MuiTypography-root': {
          color: `${headerColor} !important`,
          fontWeight: typo.fontWeightSemibold,
          fontSize: typo.fontSizeSm,
        },
        '& .MuiTableSortLabel-root': {
          color: `${headerColor} !important`,
        },
        '& .MuiTableSortLabel-icon': {
          color: `${table.sortIconColor ?? semantic.text.muted} !important`,
          opacity: 0.85,
        },
      },
    },
    bodyCell: {
      sx: {
        fontSize: typo.fontSizeMd,
        color: semantic.text.primary,
        backgroundColor: table.rowBackground ?? semantic.surfaces.surface,
        borderBottom: `1px solid ${borderColor}`,
        py: 0,
        px: `${cellPaddingX}px`,
        height: rowHeight,
        verticalAlign: 'middle',
      },
    },
    bodyRow: {
      sx: {
        backgroundColor: table.rowBackground ?? semantic.surfaces.surface,
        transition: 'background-color 140ms ease',
        '&:hover td': {
          backgroundColor: `${table.rowHoverBackground ?? semantic.surfaces.surfaceMuted} !important`,
        },
        '&:last-child td': {
          borderBottom: 'none',
        },
      },
    },
    table: {
      sx: {
        borderCollapse: 'separate',
        borderSpacing: 0,
        width: '100%',
        tableLayout: 'fixed',
      },
    },
    paper: {
      elevation: 0,
      sx: {
        boxShadow: 'none',
        borderRadius: 0,
        backgroundColor: 'transparent',
        width: '100%',
        overflow: 'visible',
      },
    },
  };
}

/** @deprecated Use createTableStyles */
export const createTableControlStyles = createTableStyles;

export function getTableSx(themeTokens, extraSx = {}) {
  return {
    ...createTableStyles(themeTokens).container.sx,
    ...extraSx,
  };
}

/** @deprecated Use getTableSx */
export const getTableControlSx = getTableSx;
